export default __webpack_public_path__ + "static/HU_Con_112_PCG1024_14-212cefa2588968894b05c6c44a2104bc.jpg";